<template>
  <!-- 续费管理 -->
  <div class="renewManage main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item">
          <span class="label">保单号</span>
          <Input clearable v-model="searchParams.policyNo" />
        </div>
        <div class="input-item">
          <span class="label">应续日</span>
          <DatePicker
            :clearable="true"
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="searchParams.yxDate"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </DatePicker>
        </div>

        <div class="input-item select-two">
          <Select style="width: 110px" :transfer="true" v-model="searchParams.multiple" class="input-item-select">
            <Option value="1" label="宽限期满日"></Option>
            <Option value="2" label="保单生效日"></Option>
            <Option value="3" label="实际续费日"></Option>
          </Select>
          <DatePicker
            class="input-item-select"
            :clearable="true"
            :transfer="true"
            type="daterange"
            v-model="searchParams.multipleDate"
            format="yyyy-MM-dd"
            placeholder="请选择时间"
          ></DatePicker>
        </div>

        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="" clearable />
        </div>

        <div class="input-item">
          <span class="label">保险公司</span>
          <Select clearable v-model="searchParams.companyCode" filterable transfer>
            <Option :value="item.code" v-for="(item, index) in companyList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">投保人</span>
          <Input v-model="searchParams.holderNameOrPhone" placeholder="请输入姓名或手机号" clearable />
        </div>

        <div class="input-item">
          <span class="label">交费年数</span>
          <Select clearable v-model="searchParams.renewalYears" filterable transfer>
            <Option :value="item.value" v-for="(item, index) in renewalYearsList" :key="index">{{ item.label }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select clearable v-model="searchParams.policyStatus" transfer>
            <Option :value="item.value" v-for="(item, index) in policyStatusList" :key="index">{{ item.label }}</Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">跟进状态</span>
          <Select clearable v-model="searchParams.serviceState" transfer>
            <Option :value="item.value" v-for="(item, index) in serviceStateList" :key="index">{{ item.label }}</Option>
          </Select>
        </div>

        <div class="input-item" v-if="searchParams.tab == 2">
          <span class="label">跟进类型</span>
          <Select clearable v-model="searchParams.payWaitType" transfer>
            <Option value="9">无法联系</Option>
            <Option value="10">有意向退保</Option>
            <Option value="11">准备续费</Option>
            <Option value="13">跟进完成</Option>
            <Option value="14">跟进终止</Option>
          </Select>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore = true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>

      <Tabs class="tabs" v-model="searchParams.tab" @on-click="toggleFirstTab" :animated="false">
        <TabPane :label="item.label + '(' + item.num + ')'" :name="item.name" v-for="item in tabs" :key="item.name"></TabPane>

        <div class="right">
          <Button style="border-color: #236dff; color: #236dff" @click="exportExcel">导出</Button>
        </div>
      </Tabs>

      <div class="tipBox clearfix">
        <div class="left clearfix" v-if="searchParams.tab == 1 || searchParams.tab == 4">
          <div>合计</div>
          <div>
            应收保费：
            <span class="other">{{ countObj.fee }}</span
            >元
          </div>

          <div>
            实收保费：
            <span class="other">{{ countObj.payFee }}</span
            >元
          </div>
        </div>
      </div>

      <div class="table-box setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableDate">
          <template slot-scope="{ row }" slot="policyNo">
            <div v-if="row.followUpAuthorized == 1" class="tag">已授权</div>
            <a class="policy-no" @click="toDetail(row)">{{ row.policyNo }}</a>
          </template>
          <div slot-scope="{ row }" slot="slotColumn" class="slot-column">
            <span v-if="row.day <= 5 || row.showRed" class="date-dian" :style="{ background: '#ED0000' }"></span>
            <span v-else-if="row.day > 5 && row.day <= 10" class="date-dian" :style="{ background: '#FF750D' }"></span>
            <span v-else-if="row.day > 11 && row.day <= 20" class="date-dian" :style="{ background: '#FFB100' }"></span>
            <span v-else-if="row.day > 20" class="date-dian" :style="{ background: '#66DD2A' }"></span>
            <span>{{ row.dayText }}</span>
          </div>
          <template slot-scope="{ row }" slot="bar">
            <div class="detail">
              <div @click="toDetail(row)">详情</div>
            </div>
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page :total="total" :current="searchParams.pageNo" :page-size="searchParams.pageSize" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import myForm from '@/components/commons/form';
import filters from '@/api/filter';
import { pageTool } from '@/api/mixins';

import { allColumns, renewalFeeColumns, renewedColumns, otherColumns } from './form/columns';
import { getAllCompany } from '@/api/httpList';
export default {
  mixins: [pageTool],
  components: {
    myForm
  },

  data() {
    return {
      rowId: null,
      tableDate: [],
      organizationList: [],
      tabs: [
        { label: '全部', name: '1', num: '' },
        { label: '待续费', name: '2', num: '' },
        { label: '续费失败', name: '3', num: '' },
        { label: '已续费', name: '4', num: '' },
        { label: '过期未续', name: '5', num: '' }
      ],
      countObj: {},
      columns: [], //表格列
      searchParams: {
        multiple: '1',
        tab: '2',
        pageNo: 1,
        pageSize: 10
      },
      companyList: [],
      renewalYearsList: [
        {
          label: '第一年',
          value: 1
        },
        {
          label: '第二年',
          value: 2
        },
        {
          label: '第三年',
          value: 3
        },
        {
          label: '第四年',
          value: 4
        },
        {
          label: '第五年',
          value: 5
        }
      ],
      policyStatusList: [
        {
          label: '已承保',
          value: '1'
        },
        {
          label: '已退保',
          value: '-1'
        },
        {
          label: '已终止',
          value: '0'
        },
        {
          label: '已中止',
          value: '2'
        }
      ],
      serviceStateList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已跟进',
          value: '2'
        },
        {
          label: '待跟进',
          value: '1'
        }
      ],
      total: 0
    };
  },

  async created() {
    this.columns = renewalFeeColumns;
    this.getInsureList();
    this.queryAllCompany();
  },

  activated() {
    this.getInsureList();
  },

  methods: {
    // 获取保司
    async queryAllCompany() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },

    // 处理时间参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchParams));

      // 应续日
      if (this.searchParams.yxDate && this.searchParams.yxDate[0]) {
        obj.needPayDateStart = filters.filterTime(this.searchParams.yxDate[0], 'YYYY-MM-DD');
        obj.needPayDateEnd = filters.filterTime(this.searchParams.yxDate[1], 'YYYY-MM-DD');
      }

      // 宽限期满日
      if (this.searchParams.multiple == 1 && this.searchParams.multipleDate && this.searchParams.multipleDate[0]) {
        obj.lastPayDateStart = filters.filterTime(this.searchParams.multipleDate[0], 'YYYY-MM-DD');
        obj.lastPayDateEnd = filters.filterTime(this.searchParams.multipleDate[1], 'YYYY-MM-DD');
      } else if (this.searchParams.multiple == 2 && this.searchParams.multipleDate && this.searchParams.multipleDate[0]) {
        // 保单生效日
        obj.policyStartDateStart = filters.filterTime(this.searchParams.multipleDate[0], 'YYYY-MM-DD');
        obj.policyStartDateEnd = filters.filterTime(this.searchParams.multipleDate[1], 'YYYY-MM-DD');
      } else if (this.searchParams.multiple == 3 && this.searchParams.multipleDate && this.searchParams.multipleDate[0]) {
        // 实际交费日
        obj.serverEndDateStart = filters.filterTime(this.searchParams.multipleDate[0], 'YYYY-MM-DD');
        obj.serverEndDateEnd = filters.filterTime(this.searchParams.multipleDate[1], 'YYYY-MM-DD');
      }

      let { yxDate, multipleDate, ...params } = obj;
      return params;
    },

    // 列表数据
    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: '/buz/policyRenewalRecord/read/list',
        type: 'POST',
        data: this.setRequestParam()
      })
        .then(res => {
          this.getStatisticsData();
          this.$root.$children[0].isShowLoading = false;
          res.data.forEach(item => {
            this.setDayText(item, res.timestamp);
          });
          this.tableDate = res.data;
          this.total = res.total;
        })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
    },
    setDayText(row, timestamp) {
      let date = row.lastPayDate;
      let text = '宽限期满日';
      const now = dayjs(new Date(timestamp)).format('YYYY-MM-DD') + ' 00:00:00';
      const dateOut = dayjs(new Date(date)).format('YYYY-MM-DD');
      if (now < date) {
        row.day = dayjs(date).diff(now, 'day');
        text = `距${text}还剩 ${row.day} 天`;
      } else if (now == date) {
        row.day = 0;
        text = `今天是${text}`;
      } else {
        row.day = dayjs(now).diff(date, 'day');
        row.showRed = true;
        text = `${text}已过 ${row.day} 天`;
      }
      row.dayText = text + '（' + dateOut + '）';
    },

    // 统计
    getStatisticsData() {
      this.$http({
        url: '/buz/policyRenewalRecord/read/statistic',
        type: 'POST',
        data: this.setRequestParam()
      }).then(res => {
        this.countObj = res.data.feeMap;
        this.tabs = this.tabs.map((item, index) => {
          return {
            ...item,
            num: res.data.tabMap[index + 1]
          };
        });
      });
    },

    // 查询
    searchAjax() {
      this.searchParams.pageNo = 1;
      this.getInsureList();
    },

    // 重置
    resetSearch() {
      this.searchParams = {
        multiple: '1',
        tab: '2',
        pageNo: 1,
        pageSize: 10
      };
      this.getInsureList();
    },

    //切换一级tab
    async toggleFirstTab(value) {
      if (value == 1) {
        this.columns = allColumns;
      } else if (value == 2) {
        this.columns = renewalFeeColumns;
      } else if (value == 4) {
        this.columns = renewedColumns;
      } else if (value == 3 || value == 5) {
        this.columns = otherColumns;
      }

      this.searchParams.pageNo = 1;
      this.searchParams.payWaitType = '';
      this.getInsureList();
    },

    // 导出
    exportExcel() {
      this.$http({
        url: '/buz/policyRenewalRecord/export',
        type: 'POST',
        forced: true,
        responseType: 'blob',
        All: true,
        data: this.setRequestParam()
      }).then(res => {
        this.$units.daochu(res);
      });
    },

    // 详情
    toDetail(row) {
      this.$router.push({
        path: '/renewalManage/renewManage/detail',
        query: {
          row: JSON.stringify(row),
          status: this.searchParams.tab
        }
      });
    },

    // 变更状态
    changeStatus(row) {
      this.rowId = row.id;
      this.$refs.followUp.open(row.commissionDTOList);
    },

    // 分页
    pageChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getInsureList();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
.tag {
  border-radius: 4px;
  width: 44px;
  height: 18px;
  line-height: 18px;
  font-size: 12px!important;
  color: #7b8daa;
  background-color: #f2f5f7;
  border: 1px solid #b7c2d0;
  display: inline-block;
  text-align: center;
}
.input-item {
  padding-right: 50px;
  .label {
    font-size: 13px;
  }
  /deep/ .ivu-select-selected-value {
    font-size: 13px !important;
  }
  /deep/ .ivu-input {
    font-size: 13px !important;
  }
}

.btn-item {
  /deep/ .ivu-btn {
    font-size: 13px;
  }
}

/deep/ .input-item-select > .ivu-select-selection {
  border-right: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

/deep/ .ivu-tabs-nav .ivu-tabs-tab-active {
  font-weight: bold;
}

/deep/ .ivu-table-cell > span {
  color: #515c6f;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}
/deep/ .formGroup {
  position: relative;
  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }
  padding: 0;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3c464f;
  }
}
/deep/ .formGroup:after {
  display: none;
}
/deep/ .base {
  margin-top: 40px;
}
/deep/ .formGroup .title {
  font-size: 18px;
  color: #272933;
  margin-bottom: 0 !important;
  border-bottom: none !important;
}
/deep/ .ivu-form-item-content {
  color: #272933;
}
/deep/ .ivu-form-item {
  margin-bottom: 12px;
}
/deep/ .ivu-modal-body {
  padding: 16px 30px;
}
/deep/ .formGroup {
  height: unset !important;
  position: relative;
  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }
  padding: 0;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3c464f;
  }
}
.slot-column {
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-dian {
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
}
</style>